namespace aq.ui {

    export class AqSidebarNavItemController implements common.models.SidebarNavItem {

        public isLargeScreen: () => boolean;
        public isMediumScreen: () => boolean;
        public sidebarNavClose: () => void;
        public parent: AqSidebarNavController;
        public title: string;
        public state: string;
        public stateData: any;
        public stateOptions: any;
        public icon: string;
        public aria: string;
        public isActiveFn: () => boolean;
        public actionFn: () => boolean;
        private isTooltipVisible: boolean;
        private htmlColor: string;
        private listItemContentTemplateUrl: string;

        /* @ngInject */
        constructor(private SidebarNavHelperService: aq.services.SidebarNavHelperService, private $mdMedia: angular.material.IMedia) {
            this.title = '';
            this.state = '';
            this.stateData = null;
            this.stateOptions = null;
            this.icon = '';
            this.aria = '';
            this.listItemContentTemplateUrl = 'app/common/directives/aqSidebarNav/aqSidebarNavItem/aqListItemContent.html';
        }
        public $onChanges(changesObj) {
            const navItem: common.models.SidebarNavItem = {
                title: changesObj.title ? changesObj.title.currentValue : '',
                state: changesObj.state ? changesObj.state.currentValue : '',
                stateData: changesObj.stateData ? changesObj.stateData.currentValue : null,
                stateOptions: changesObj.stateOptions ? changesObj.stateOptions.currentValue : null,
                icon: changesObj.icon ? changesObj.icon.currentValue : '',
                aria: changesObj.aria ? changesObj.aria.currentValue : ''
            };

            this.SidebarNavHelperService.populateMissingMenuItemData(navItem);
            // prevent resetting values which have already been initialized (i.e. late binding of building selector)
            if (!this.title) { this.title = navItem.title; }
            if (!this.state) { this.state = navItem.state; }
            if (!this.icon) { this.icon = navItem.icon; }
            if (!this.aria) { this.aria = navItem.aria; }
            if (!this.stateData) { this.stateData = navItem.stateData; }
            if (!this.stateOptions) { this.stateOptions = navItem.stateOptions; }
            if (!this.icon) {
                this.htmlColor = this.SidebarNavHelperService.getColorFromString(this.title);
            }
        }
        public $onInit() {
            this.isLargeScreen = () => this.parent.isLargeScreen();
            this.isMediumScreen = () => this.parent.isMediumScreen();
            this.sidebarNavClose = () => this.parent.close();
        }
        private setMouseOver(isOver: boolean) {
            this.isTooltipVisible = isOver;
        }
        private isTooltipEnabled(): boolean {
            return !this.isLargeScreen() && this.isMediumScreen() || this.title.length > 22 && this.$mdMedia('min-width: 457px');
        }
        private isMaterialIcon(): boolean {
            return this.icon && this.icon.substring(0, 1) != '.';
        }
        private parseNonMaterialIcon(): string {
            let iconClass = this.icon.substring(1);
            const sizeClass = this.SidebarNavHelperService.getIconSizeClass(iconClass);
            if (sizeClass) {
                iconClass = iconClass + ' ' + sizeClass;
            }
            return iconClass;
        }
        private getIconLetter() {
            return this.title.length > 0 ? this.title.substring(0, 1) : '';
        }
        private navItemClick() {
            if (this.actionFn) {
                this.actionFn();
            }
            this.closeIfMobile();
        }
        private closeIfMobile() {
            if (!this.isLargeScreen()) {
                this.sidebarNavClose();
                this.isTooltipVisible = false;
            }
        }
    }

    angular
        .module('aq.ui')
        .component('aqSidebarNavItem', {
            templateUrl: 'app/common/directives/aqSidebarNav/aqSidebarNavItem/aqSidebarNavItem.html',
            controller: AqSidebarNavItemController,
            controllerAs: 'vm',
            bindings: {
                title: '@',
                state: '@?',
                stateData: '<?',
                stateOptions: '<?',
                icon: '@?',
                aria: '@?',
                isActiveFn: '&?',
                actionFn: '&?'
            },
            require: {
                parent: '^^aqSidebarNav'
            }
        });
}
